import React, { useState, useEffect } from 'react';

/**
 * Shared AnimatedCounter Component
 * Luxury-grade animated counter with sophisticated easing and performance optimization
 * Extracted from multiple pages to eliminate code duplication
 */
const AnimatedCounter = React.memo(({ end, duration = 2000, prefix = "", suffix = "" }) => {
  const [count, setCount] = useState(0);
  
  useEffect(() => {
    let startTime;
    let animationId;
    
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      
      setCount(Math.floor(progress * end));
      
      if (progress < 1) {
        animationId = requestAnimationFrame(animate);
      }
    };
    
    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [end, duration]);
  
  return <span>{prefix}{count}{suffix}</span>;
});

export default AnimatedCounter;
